<template>
  <div class="user-menu">
    <a v-html="notificationIcon"
       class="profile-button"
       :class="{'active': notificationsVisible, 'notification-dot': notificationsCount > 0 }"
       href="#"
       @click.prevent="toggleNotifications">
    </a>
  </div>
</template>

<script>
import { customEvent } from '@/services/customEventBus'
import { notification } from '@/components/common/icons/svgIcons'
import errorMessageHandler from '@/mixins/errorMessageHandler'

export default {
  name: 'user-notifications',
  mixins: [errorMessageHandler],
  data () {
    return {
      notificationsVisible: false,
      notificationsCount: 0
    }
  },
  computed: {
    notificationIcon () {
      return notification
    }
  },
  methods: {
    toggleNotifications () {
      this.notificationsVisible = !this.notificationsVisible
      customEvent.$emit('notification:toggle', this.notificationsVisible)
      if (this.notificationsVisible) {
        customEvent.$emit('notifications:list')
      }
    },
    setStateToClosed () {
      this.notificationsVisible = false
    }
  },
  mounted () {
    customEvent.$on('notification:close', this.setStateToClosed)
    this.$nextTick(() => {
      customEvent.$on('notification:count', count => {
        this.notificationsCount = count
      })
      customEvent.$emit('notification-icon:loaded')
    })
  },
  beforeDestroy () {
    customEvent.$off('notification:close')
    customEvent.$off('notification:count')
  }
}
</script>

<style scoped lang="scss" src="./styles/dropdown.scss"></style>
